import { render, staticRenderFns } from "./SupervisorDialog.vue?vue&type=template&id=7ded13db"
import script from "./SupervisorDialog.vue?vue&type=script&lang=js"
export * from "./SupervisorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports